<div class="login-container">
  <div class="login-form-container">
    <div class="form-field">
      <app-input-field [type]="'email'" [placeholder]="getString('emailAddress')" [autocomplete]="'email'" [name]="'email'" (valueChanged)="onEmailChange($event)"></app-input-field>
    </div>
    <div class="form-field">
      <app-input-field [type]="'password'" [placeholder]="getString('password')" [autocomplete]="'current-password'" [name]="'password'" (valueChanged)="onPasswordChange($event)" (enterPressed)="onPasswordEnterPressed()"></app-input-field>
    </div>

    <div class="password-forgotten">
      {{getString('passwordForgotten')}} <a (click)="resetPasswordClicked()">{{getString('resetPassword')}}</a>
    </div>

    <div class="errors-container red-text">
        <span class="block" *ngIf="!success">{{getString('loginFailed')}}</span>
        <span class="block" *ngIf="serverError">{{serverErrorMessage}}</span>
        <span class="block" *ngIf="emailInvalid">{{getString('invalidEmail')}}</span>
        <span class="block" *ngIf="formIncomplete">{{getString('formIsIncomplete')}}</span>
    </div>

    <div class="form-field">
      <button class="login-button blue-button" type="button" (click)="login()">{{getString('login')}}</button>
    </div>

    <div class="or-container">
      {{getString('or')}}
    </div>

    <div class="fb-btn-container">
      <app-facebook-login-button (onClick)="FBLogin()"></app-facebook-login-button>
      <app-sign-in-apple></app-sign-in-apple>
    </div>

    <div class="register-btn">
      <a (click)="registerClicked()">{{getString('noAccountYet')}}</a>
    </div>

  </div>
</div>